import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  MenuItem,
  Typography,
} from "@mui/material";
import React from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";
import { useNavigate } from "react-router-dom";

export const OrderInformation: React.FC<any> = React.memo(
  ({ open, onClose }) => {
    const { control, register,handleSubmit } = useForm();
    const navigate = useNavigate()
    const onSubmit = async (data: any) => {
        debugger;
        console.log("onsubmit===>", data); // You can perform any action with the submitted data here
      };

      const handleClick = (path:string) =>{
            navigate(path)
      }
    return (
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth='md'
        PaperProps={{
          style: {
            
            height: "40rem", // Set your desired height (if needed)
            backgroundColor: "whitesmoke",
          },
        }}
      >
<form onSubmit={handleSubmit(onSubmit)}>     
            <DialogTitle sx={{ backgroundColor: "green" }}>
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography variant="h6" color={"white"}>
              Order Information
            </Typography>
            <IconButton onClick={onClose}>
              <WSIcons.CloseIcon sx={{ color: "white" }} />
            </IconButton>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} sm={3}>
              <Typography>Deliver Date</Typography>
            </Grid>
            <Grid item xs={12} sm={5}>
              <WSDateField
                id="deliverdate"
                name="deliverdate"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <WSTextField
                label={"Deliver Time"}
                {...register("delivertime")}
                id="delivertime"
                name="delivertime"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>Waiter Name</Typography>
            </Grid>
            <Grid item xs={12} sm={5}>
              <WSSelectField
                rules={{ required: true }}
                {...register("waitername")}
                id="waitername"
                control={control}
                defaultValue={"0"}
                label=""
                name="waitername"
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <WSTextField
                label={"waitercode"}
                {...register("waitercode")}
                id="waitercode"
                name="waitercode"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>First Name</Typography>
            </Grid>

            <Grid item xs={12} sm={5}>
              <WSTextField
                label={""}
                {...register("firstname")}
                id="firstname"
                name="firstname"
                control={control}
                rules={{ required: true }}
              />
            </Grid>

            <Grid item xs={12} sm={4}>
              <Grid
                display="flex"
                justifyContent="flex-start"
                alignItems="center"
                gap={6}
              >
                <WSIcons.RoomServiceIcon onClick={()=>handleClick('/guestfolio')}/>
                <WSIcons.SearchIcon  onClick={()=>handleClick('/guestsearchorder')}/>
                <WSIcons.Person onClick={()=>handleClick('/guestinformation')}/>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>Last Name</Typography>
            </Grid>

            <Grid item xs={12} sm={9}>
              <WSTextField
                label={""}
                {...register("lastname")}
                id="lastname"
                name="lastname"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>#Adult</Typography>
            </Grid>

            <Grid item xs={12} sm={4}>
              <WSTextField
                label={""}
                {...register("adult")}
                id="adult"
                name="adult"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={2}>
              <Typography>#Child</Typography>
            </Grid>

            <Grid item xs={12} sm={3}>
              <WSTextField
                label={""}
                {...register("child")}
                id="child"
                name="child"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography> Date</Typography>
            </Grid>
            <Grid item xs={12} sm={9}>
              <WSDateField
                id="date"
                name="date"
                dateFormat="D/MM/YYYY"
                control={control}
                defaultValue={null}
                rules={{ required: true }}
                label={""}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>Remark</Typography>
            </Grid>

            <Grid item xs={12} sm={9}>
              <WSTextField
                label={""}
                {...register("remark")}
                id="remark"
                name="remark"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>Citizen ID</Typography>
            </Grid>

            <Grid item xs={12} sm={9}>
              <WSTextField
                label={""}
                {...register("citizenid")}
                id="citizenid"
                name="citizenid"
                control={control}
                rules={{ required: true }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <Typography>Business Source</Typography>
            </Grid>

            <Grid item xs={12} sm={9}>
              <WSSelectField
                rules={{ required: true }}
                {...register("businesssource")}
                id="businesssource"
                control={control}
                defaultValue={"0"}
                label=""
                name="businesssource"
              />
            </Grid>
          </Grid>
        </DialogContent>
        <Grid
          item
          sx={{
            backgroundColor: "#333",
            padding: "1rem",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Grid container spacing={2} alignItems="center" gap={3}>
            <Grid item>
              <WSIcons.GTranslateIcon sx={{ color: "white" }} />
            </Grid>
          </Grid>

          <Button
            variant="contained"
            sx={{
              backgroundColor: "green",
              "&:hover": {
                backgroundColor: "#388e3c",
              },
              
            }}
            onClick={handleSubmit(onSubmit)}
          >
            Finish
          </Button>
        </Grid>
        </form>
      </Dialog>
    );
  }
);
